import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { Machine } from "./get-machine-by-id";
import { Skill } from "@src/types/skill-types";

export interface MachineWithSkills extends Machine {
  skills?: Skill[];
}

export interface GetMachinesWithSkillsResponse {
  machines: MachineWithSkills[];
}

export const getMachinesWithSkills = async (
  namespace: string,
): Promise<GetMachinesWithSkillsResponse> => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  try {
    const response = await axios.get<GetMachinesWithSkillsResponse>(
      `${url}/api/v4/ns/${namespace}/machines-skills`,
      { headers },
    );

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      console.error("Axios error:", error);
      throw error;
    }

    throw new Error(
      "An unexpected error occurred while fetching machines and skills.",
    );
  }
};
